import { render, staticRenderFns } from "./DetailsTableV2.vue?vue&type=template&id=d32415c8"
import script from "./DetailsTableV2.vue?vue&type=script&lang=js"
export * from "./DetailsTableV2.vue?vue&type=script&lang=js"
import style0 from "./DetailsTableV2.vue?vue&type=style&index=0&id=d32415c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports